import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./PilotVehicles.css";
import PopupMessage from "../PopupMessage/PopupMessage";
import { fetchPilotsAndVehicles, updateVehicleUIN, updateVehicleMissionLimit, addVehicleServiceHistory } from "../Apis/AdminApis";
import pavamanLogo from "../images/drone.png";
import { PiDroneBold } from "react-icons/pi";
import {
  FiSearch,
  FiX,
  FiEdit2,
  FiCalendar,
  FiTruck,
  FiUsers,
  FiCheckCircle,
  FiAlertCircle,
  FiInfo,
  FiRefreshCw,
  FiChevronLeft,
  FiChevronRight,
  FiTag,
  FiActivity,
  FiClock,
  FiShield,
  FiAward,
  FiTool,
  FiPlus,
  FiEye,
  FiUser,
  FiFileText
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const PilotVehicles = () => {
   const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPaginationLoading, setIsPaginationLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: 'vehicle_name', direction: 'asc' });
  const [uinFilter, setUinFilter] = useState("all");
  const [missionLimit, setMissionLimit] = useState("");
  const [role, setRole] = useState("");
  const [viewModeInfo, setViewModeInfo] = useState("");
  const [serviceFormData, setServiceFormData] = useState({
    service_date: "",
    serviced_by: "",
    remarks: ""
  });
  const [addingService, setAddingService] = useState(false);
  // const [vehicleHasService, setVehicleHasService] = useState({});
  
  const [editFormData, setEditFormData] = useState({
    vehicle_id: "",
    uin: "",
    registered_date: ""
  });

  useEffect(() => {
    loadVehicles();
    const userRole = localStorage.getItem("role") || sessionStorage.getItem("role");
    setRole(userRole);
  }, []);

  // const checkVehicleServiceExists = async (vehicleId) => {
  //   try {
  //     const res = await viewVehicleServiceHistory({
  //       vehicle_id:vehicleId,
  //       page: 1,
  //       page_size: 1
  //     });
  //     return res?.history && res.history.length > 0;
  //   } catch {
  //     return false;
  //   }
  // };

  // const loadServiceStatus = async (vehiclesList) => {
  //   const serviceStatus = {};
  //   for (const vehicle of vehiclesList) {
  //     serviceStatus[vehicle.vehicle_id] = await checkVehicleServiceExists(vehicle.vehicle_id);
  //   }
  //   setVehicleHasService(serviceStatus);
  // };

  const loadVehicles = async () => {
    try {
      setLoading(true);
      const res = await fetchPilotsAndVehicles({ action: "view" });

      if (res?.error) {

  // ✅ Session expired handling
  if (res.error === "Unauthorized") {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    setLoading(false);
    return;
  }

  setPopupMessage(res.error);
  setPopupType("error");
  setPopupOpen(true);
  setLoading(false);
  return;
}

   const formattedVehicles = (res.vehicles || []).map(vehicle => ({
  vehicle_id: vehicle.vehicle_id || vehicle.id,
  vehicle_name: vehicle.vehicle_name,
  uin: vehicle.uin || "",
  registered_date: vehicle.registered_date,
  created_at: vehicle.created_at,
  admin_id: vehicle.admin_id,
  admin_name: vehicle.admin_name,
  is_superadmin_company: vehicle.is_superadmin_company,
  mission_count: vehicle.mission_count || 0,
  max_missions_allowed: vehicle.max_missions_allowed || 0,
  is_limit_reached: vehicle.is_limit_reached || false,
  service_status: vehicle.service_status || false
}));

      setVehicles(formattedVehicles);
      setFilteredVehicles(formattedVehicles);
      setViewModeInfo(res.view_mode || "");
      setCurrentPage(1);
      
      // await loadServiceStatus(formattedVehicles);
      
    } catch (error) {
      console.error("Error loading vehicles:", error);
      setPopupMessage("Failed to load vehicles data");
      setPopupType("error");
      setPopupOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEditVehicle = (vehicle) => {
    setSelectedVehicle(vehicle);
    
    let formattedDate = "";
    if (vehicle.registered_date) {
      try {
        const date = new Date(vehicle.registered_date);
        formattedDate = date.toISOString().split('T')[0];
      } catch {
        formattedDate = vehicle.registered_date;
      }
    }
    
    setEditFormData({
      vehicle_id: vehicle.vehicle_id,
      uin: vehicle.uin || "",
      registered_date: formattedDate
    });
    
    setShowEditModal(true);
  };

  const handleAddService = (vehicle) => {
    setSelectedVehicle(vehicle);
    setServiceFormData({
      service_date: new Date().toISOString().split('T')[0],
      serviced_by: "",
      remarks: ""
    });
    setShowServiceModal(true);
  };

  const handleViewService = (vehicle) => {
    navigate(`/vehicle-service-history?vehicle=${vehicle.vehicle_id}`);
  };

const handleSubmitService = async () => {

  if (!selectedVehicle?.vehicle_id) {
    setPopupMessage("Vehicle ID missing");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  if (!serviceFormData.service_date) {
    setPopupMessage("Service date is required");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  if (!serviceFormData.serviced_by.trim()) {
    setPopupMessage("Serviced By is required");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  try {
    setAddingService(true);

    const payload = {
      action: "add", // ✅ REQUIRED
      vehicle_id: selectedVehicle.vehicle_id,
      service_date: serviceFormData.service_date,
      serviced_by: serviceFormData.serviced_by.trim(),
      remarks: serviceFormData.remarks || ""
    };

    console.log("Service Payload:", payload);

    const res = await addVehicleServiceHistory(payload);

    if (res?.error) {

      // ✅ Session expired handling
      if (res.error === "Unauthorized") {
        setPopupMessage("Session expired, redirecting to login page");
        setPopupType("error");
        setPopupOpen(true);

        setTimeout(() => {
          navigate("/login");
        }, 2000);

        return;
      }

      setPopupMessage(res.error);
      setPopupType("error");
      setPopupOpen(true);
      return;
    }

    setPopupMessage(res.message || "Service record added successfully");
    setPopupType("success");
    setPopupOpen(true);

    // ✅ Update service button immediately
    // setVehicleHasService((prev) => ({
    //   ...prev,
    //   [selectedVehicle.vehicle_id]: true
    // }));

    closeServiceModal();

  } catch (error) {
    console.error("Service Error:", error);

    setPopupMessage(
      error.response?.data?.error || "Failed to add service record"
    );

    setPopupType("error");
    setPopupOpen(true);

  } finally {
    setAddingService(false);
  }
};

  const handleUpdateVehicleUIN = async () => {
    try {
      if (!editFormData.uin.trim()) {
        setPopupMessage("UIN is required");
        setPopupType("error");
        setPopupOpen(true);
        return;
      }

      if (!editFormData.registered_date) {
        setPopupMessage("Registered date is required");
        setPopupType("error");
        setPopupOpen(true);
        return;
      }

      const payload = {
        vehicle_id: editFormData.vehicle_id,
        uin: editFormData.uin.trim(),
        registered_date: editFormData.registered_date
      };

      const res = await updateVehicleUIN(payload);

     if (res?.error) {

  // ✅ Session expired handling
  if (res.error === "Unauthorized") {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    setLoading(false);
    return;
  }

  setPopupMessage(res.error);
  setPopupType("error");
  setPopupOpen(true);
  setLoading(false);
  return;
}

      setPopupMessage(res.message || "Vehicle UIN updated successfully");
      setPopupType("success");
      setPopupOpen(true);

      setShowEditModal(false);
      setSelectedVehicle(null);
      loadVehicles();

    } catch (error) {
      console.error("Error updating vehicle:", error);
      setPopupMessage(error.response?.data?.error || "Failed to update vehicle UIN");
      setPopupType("error");
      setPopupOpen(true);
    }
  };

  const handleUpdateAllVehiclesMissionLimit = async () => {
    try {
      if (!missionLimit) {
        setPopupMessage("Please enter max missions for all vehicles");
        setPopupType("error");
        setPopupOpen(true);
        return;
      }

      const payload = {
        max_missions: Number(missionLimit)
      };

      const res = await updateVehicleMissionLimit(payload);
      if (res?.error) {

  // ✅ Session expired handling
  if (res.error === "Unauthorized") {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    setLoading(false);
    return;
  }

  setPopupMessage(res.error);
  setPopupType("error");
  setPopupOpen(true);
  setLoading(false);
  return;
}
      setPopupMessage(`${res.message}: ${res.updated_count} vehicles updated`);
      setPopupType("success");
      setPopupOpen(true);
      setMissionLimit("");
      loadVehicles();
    } catch (err) {
      setPopupMessage("Something went wrong");
      setPopupType("error");
      setPopupOpen(true);
    }
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setSelectedVehicle(null);
    setEditFormData({
      vehicle_id: "",
      uin: "",
      registered_date: ""
    });
  };

  const closeServiceModal = () => {
    setShowServiceModal(false);
    setSelectedVehicle(null);
    setServiceFormData({
      service_date: "",
      serviced_by: "",
      remarks: ""
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Not registered";
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  useEffect(() => {
    let filtered = [...vehicles];
    if (searchTerm) {
      filtered = filtered.filter(vehicle => 
        vehicle.vehicle_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        vehicle.vehicle_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (vehicle.uin && vehicle.uin.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (vehicle.admin_name && vehicle.admin_name.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }
    
    if (uinFilter !== "all") {
      filtered = filtered.filter(vehicle =>
        uinFilter === "registered" ? vehicle.uin && vehicle.uin.trim() : !vehicle.uin || !vehicle.uin.trim()
      );
    }
    
    filtered.sort((a, b) => {
      let aVal = a[sortConfig.key] || "";
      let bVal = b[sortConfig.key] || "";
      if (typeof aVal === 'string') aVal = aVal.toLowerCase();
      if (typeof bVal === 'string') bVal = bVal.toLowerCase();
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
    
    setFilteredVehicles(filtered);
    setCurrentPage(1);
  }, [searchTerm, uinFilter, vehicles, sortConfig]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentVehicles = filteredVehicles.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredVehicles.length / itemsPerPage);
  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc'
    });
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setIsPaginationLoading(true);
      setCurrentPage(newPage);
      setTimeout(() => setIsPaginationLoading(false), 300);
    }
  };
  const totalVehicles = vehicles.length;
  const vehiclesWithUIN = vehicles.filter(v => v.uin && v.uin.trim()).length;
  const vehiclesNearLimit = vehicles.filter(v => v.is_limit_reached || (v.mission_count >= v.max_missions_allowed * 0.8)).length;

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '↑' : '↓';
    }
    return '';
  };

  const getMissionStatus = (current, max) => {
    if (!max) return { status: 'inactive', color: '#94a3b8', bg: '#f1f5f9' };
    const percentage = (current / max) * 100;
    if (percentage >= 100) return { status: 'critical', color: '#dc2626', bg: '#fee2e2' };
    if (percentage >= 80) return { status: 'warning', color: '#f59e0b', bg: '#fed7aa' };
    return { status: 'normal', color: '#10b981', bg: '#d1fae5' };
  };

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />

      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Vehicle Management</h1>
            <p className="dashboard-subtitle">Manage your drone fleet, track UIN assignments, and monitor mission usage</p>
          </div>
        </div>

        {viewModeInfo === "superadmin" && (
          <div className="pv-top-action-card">
            <h3 style={{ marginBottom: "10px" }}>Update Mission Limit For All Vehicles</h3>
            <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
              <input
                type="number"
                placeholder="Enter max missions for ALL vehicles"
                value={missionLimit}
                onChange={(e) => setMissionLimit(e.target.value)}
                className="pv-form-input"
                style={{ width: "250px" }}
              />
              <button
                className="pv-btn pv-btn-primary"
                onClick={handleUpdateAllVehiclesMissionLimit}
              >
                <FiActivity size={16} />
                Update All Vehicles
              </button>
            </div>
            <small style={{ color: "#64748b", marginTop: "8px", display: "block" }}>
              ⚠️ This will update the mission limit for ALL vehicles in the system at once
            </small>
          </div>
        )}

        <div className="pv-filter-card">
          <div className="pv-search-bar">
            <FiSearch className="pv-search-icon" />
            <input
              type="text"
              placeholder="Search by vehicle name, ID, UIN, or company..."
              className="pv-search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button className="pv-clear-search" onClick={() => setSearchTerm("")}>
                <FiX size={18} />
              </button>
            )}
          </div>

          <div className="pv-filter-group">
            <div className="pv-filter-chip-group">
              <span className="pv-filter-label">UIN Status:</span>
              <div className="pv-chips">
                <button
                  className={`pv-chip ${uinFilter === "all" ? "active" : ""}`}
                  onClick={() => setUinFilter("all")}
                >
                  All
                </button>
                <button
                  className={`pv-chip ${uinFilter === "registered" ? "active" : ""}`}
                  onClick={() => setUinFilter("registered")}
                >
                  Registered
                </button>
                <button
                  className={`pv-chip ${uinFilter === "missing" ? "active" : ""}`}
                  onClick={() => setUinFilter("missing")}
                >
                  Missing UIN
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="pv-results-bar">
          {searchTerm && (
            <div className="pv-active-filters">
              <span className="pv-filter-badge">
                Search: "{searchTerm}"
                <button onClick={() => setSearchTerm("")}>×</button>
              </span>
            </div>
          )}
        </div>

        {loading ? (
          <div className="pv-loading-state">
            <img src={pavamanLogo} alt="Loading" className="pv-loading-logo" />
            <p>Loading Vehicles data...</p>
          </div>
        ) : filteredVehicles.length === 0 ? (
          <div className="pv-empty-state">
            <div className="pv-empty-icon">🚁</div>
            <h3>No vehicles found</h3>
            <p>Try adjusting your search or filter criteria</p>
          </div>
        ) : (
          <>
            <div className="tr-table-container">
              <table className="tr-table">
                <thead className="tr-head">
                  <tr>
                    <th onClick={() => handleSort('vehicle_name')} className="pv-sortable">
                      Vehicle <span className="pv-sort-arrow">{getSortArrow('vehicle_name')}</span>
                    </th>
                    <th onClick={() => handleSort('vehicle_id')} className="pv-sortable">
                      Vehicle ID <span className="pv-sort-arrow">{getSortArrow('vehicle_id')}</span>
                    </th>
                    <th>UIN</th>
                    <th onClick={() => handleSort('registered_date')} className="pv-sortable">
                      Registered <span className="pv-sort-arrow">{getSortArrow('registered_date')}</span>
                    </th>
                    <th>Missions</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentVehicles.map((vehicle, idx) => {
                    const missionStatus = getMissionStatus(vehicle.mission_count, vehicle.max_missions_allowed);
                    return (
                      <tr key={idx}>
                        <td>
                          <div className="pv-vehicle-cell">
                            <div className="pv-vehicle-icon">
                              <PiDroneBold  size={18} />
                            </div>
                            <div className="pv-vehicle-info">
                              <span className="pv-vehicle-name">{vehicle.vehicle_name}</span>
                              {vehicle.admin_name && viewModeInfo === "superadmin" && (
                                <span className="pv-company-tag">{vehicle.admin_name}</span>
                              )}
                            </div>
                          </div>
                        </td>
                        <td>
                          <code className="pv-vehicle-id">{vehicle.vehicle_id}</code>
                        </td>
                        <td>
                          {vehicle.uin ? (
                            <span className="pv-badge pv-badge-success">
                              <FiCheckCircle size={12} />
                              {vehicle.uin}
                            </span>
                          ) : (
                            <span className="pv-badge pv-badge-warning">
                              <FiAlertCircle size={12} />
                              Not set
                            </span>
                          )}
                        </td>
                        <td>
                          <div className="pv-date-cell">
                            <FiCalendar size={14} />
                            <span>{formatDate(vehicle.registered_date)}</span>
                          </div>
                        </td>
                        <td>
                          <div className="pv-mission-cell">
                            <div className="pv-mission-stats">
                              <span className="pv-mission-count">{vehicle.mission_count || 0}</span>
                              <span className="pv-mission-sep">/</span>
                              <span className="pv-mission-limit">{vehicle.max_missions_allowed || '∞'}</span>
                            </div>
                            {vehicle.max_missions_allowed > 0 && (
                              <div className="pv-mission-bar">
                                <div 
                                  className="pv-mission-fill" 
                                  style={{ 
                                    width: `${Math.min((vehicle.mission_count / vehicle.max_missions_allowed) * 100, 100)}%`,
                                    backgroundColor: missionStatus.color
                                  }}
                                ></div>
                              </div>
                            )}
                            {vehicle.is_limit_reached && (
                              <span className="pv-badge pv-badge-warning" style={{ fontSize: "10px", marginTop: "4px" }}>
                                Limit Reached
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <button 
                            className="pv-action-btn pv-action-edit"
                            onClick={() => handleEditVehicle(vehicle)}
                            title="Edit UIN"
                          >
                            <FiEdit2 size={16} />
                            <span>Edit</span>
                          </button>
                        <>
{/* ADD / VIEW SERVICE BUTTON LOGIC */}
{vehicle.service_status ? (
  <button
    className="pv-action-btn pv-action-service"
    onClick={() => handleViewService(vehicle)}
    title="View Service History"
    style={{
      background: "#8b5cf6",
      display: "inline-flex",
       marginLeft: "0.5rem",
      marginRight: "0.5rem",
      alignItems: "center",
      gap: "0.375rem"
    }}
  >
    <FiEye size={16} />
    <span>View Service</span>
  </button>
) : (
  <button
    className="pv-action-btn pv-action-service"
    onClick={() => handleAddService(vehicle)}
    title="Add Service Record"
    style={{
      background: "#10b981",
      display: "inline-flex",
       marginLeft: "0.5rem",
      marginRight: "0.5rem",
      alignItems: "center",
      gap: "0.375rem"
    }}
  >
    <FiPlus size={16} />
    <span>Add Service</span>
  </button>
)}
</>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
               </table>
            </div>

            {totalPages > 1 && (
              <div className="pv-pilot-pagination-wrapper">
                <div className="pv-pilot-pagination-controls">
                  <button
                    className="pv-pilot-pagination-btn"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1 || isPaginationLoading}
                  >
                    <FiChevronLeft size={16} />
                    Previous
                  </button>
                  
                  <div className="pv-pilot-page-numbers">
                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      let pageNumber;
                      if (totalPages <= 5) {
                        pageNumber = i + 1;
                      } else if (currentPage <= 3) {
                        pageNumber = i + 1;
                      } else if (currentPage >= totalPages - 2) {
                        pageNumber = totalPages - 4 + i;
                      } else {
                        pageNumber = currentPage - 2 + i;
                      }
                      
                      return (
                        <button
                          key={pageNumber}
                          className={`pv-pilot-page-btn ${currentPage === pageNumber ? 'pv-pilot-active' : ''}`}
                          onClick={() => handlePageChange(pageNumber)}
                          disabled={isPaginationLoading}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}
                  </div>
                  
                  <button
                    className="pv-pilot-pagination-btn"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages || isPaginationLoading}
                  >
                    Next
                    <FiChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {showEditModal && selectedVehicle && (
        <div className="pv-modal-overlay" onClick={closeEditModal}>
          <div className="pv-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pv-modal-header">
              <h2>
                <FiEdit2 size={20} />
                Edit Vehicle UIN
              </h2>
              <button className="pv-modal-close" onClick={closeEditModal}>
                <FiX size={20} />
              </button>
            </div>

            <div className="pv-modal-body">
              <div className="pv-vehicle-preview">
                <div className="pv-preview-icon">
                  <PiDroneBold size={32} />
                </div>
                <div className="pv-preview-details">
                  <h3>{selectedVehicle.vehicle_name}</h3>
                  <p>ID: {selectedVehicle.vehicle_id}</p>
                </div>
              </div>

              <div className="pv-form-field">
                <label>
                  <FiTag size={14} />
                  Unique Identification Number (UIN) <span className="pv-required">*</span>
                </label>
                <input 
                  type="text" 
                  value={editFormData.uin} 
                  onChange={(e) => setEditFormData({...editFormData, uin: e.target.value})}
                  placeholder="Enter UIN (e.g., DR-2024-001-XX)"
                  className="pv-form-input"
                  autoFocus
                />
              </div>

              <div className="pv-form-field">
                <label>
                  <FiCalendar size={14} />
                  Registration Date <span className="pv-required">*</span>
                </label>
                <input 
                  type="date" 
                  value={editFormData.registered_date} 
                  onChange={(e) => setEditFormData({...editFormData, registered_date: e.target.value})}
                  className="pv-form-input"
                />
              </div>

              <div className="pv-mission-info">
                <div className="pv-mission-info-item">
                  <span className="pv-label">Missions Completed:</span>
                  <span className="pv-value">{selectedVehicle.mission_count || 0}</span>
                </div>
                <div className="pv-mission-info-item">
                  <span className="pv-label">Max Missions Allowed:</span>
                  <span className="pv-value">{selectedVehicle.max_missions_allowed}</span>
                </div>
              </div>
            </div>

            <div className="pv-modal-footer">
              <button className="pv-btn pv-btn-secondary" onClick={closeEditModal}>
                Cancel
              </button>
              <button className="pv-btn pv-btn-primary" onClick={handleUpdateVehicleUIN}>
                <FiCheckCircle size={16} />
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Service Modal */}
      {showServiceModal && selectedVehicle && (
        <div className="pv-modal-overlay" onClick={closeServiceModal}>
          <div className="pv-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pv-modal-header">
              <h2>
                <FiTool size={20} />
                Add Service Record
              </h2>
              <button className="pv-modal-close" onClick={closeServiceModal}>
                <FiX size={20} />
              </button>
            </div>

            <div className="pv-modal-body">
              <div className="pv-vehicle-preview">
                <div className="pv-preview-icon">
                  <PiDroneBold size={32} />
                </div>
                <div className="pv-preview-details">
                  <h3>{selectedVehicle.vehicle_name}</h3>
                  <p>ID: {selectedVehicle.vehicle_id}</p>
                </div>
              </div>

              <div className="pv-form-field">
                <label>
                  <FiCalendar size={14} />
                  Service Date <span className="pv-required">*</span>
                </label>
                <input 
                  type="date" 
                  value={serviceFormData.service_date} 
                  onChange={(e) => setServiceFormData({...serviceFormData, service_date: e.target.value})}
                  className="pv-form-input"
                  max={new Date().toISOString().split('T')[0]}
                  required
                />
              </div>

              <div className="pv-form-field">
                <label>
                  <FiUser size={14} />
                  Serviced By <span className="pv-required">*</span>
                </label>
                <input 
                  type="text" 
                  value={serviceFormData.serviced_by} 
                  onChange={(e) => setServiceFormData({...serviceFormData, serviced_by: e.target.value})}
                  placeholder="Enter technician name or service center"
                  className="pv-form-input"
                />
              </div>

              <div className="pv-form-field">
                <label>
                  <FiFileText size={14} />
                  Remarks
                </label>
                <textarea 
                  className="vsh-form-textarea"
                  value={serviceFormData.remarks} 
                  onChange={(e) => setServiceFormData({...serviceFormData, remarks: e.target.value})}
                  placeholder="Enter any additional notes about the service..."
                  rows="3"
                />
              </div>

              <div className="pv-mission-info">
                <div className="pv-mission-info-item">
                  <span className="pv-label">Missions Completed:</span>
                  <span className="pv-value">{selectedVehicle.mission_count || 0}</span>
                </div>
                <div className="pv-mission-info-item">
                  <span className="pv-label">Max Missions Allowed:</span>
                  <span className="pv-value">{selectedVehicle.max_missions_allowed || '∞'}</span>
                </div>
              </div>
            </div>

            <div className="pv-modal-footer">
              <button className="pv-btn pv-btn-secondary" onClick={closeServiceModal}>
                Cancel
              </button>
              <button 
                className="pv-btn pv-btn-primary" 
                onClick={handleSubmitService}
                disabled={addingService}
              >
                <FiCheckCircle size={16} />
                {addingService ? "Adding..." : "Add Service Record"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PilotVehicles;